import * as tslib_1 from "tslib";
import { Utils } from 'cc-common';
import { Exclude, Type } from 'class-transformer';
import { UserPortfolioProfileResultDto } from '../user-portfolio-profile-result-dto';
const ɵ0 = () => UserPortfolioProfileResultDto, ɵ1 = () => UserPortfolioProfileResultDto, ɵ2 = () => Date, ɵ3 = () => Date, ɵ4 = () => Date;
export class UserCommunitiesResultDto {
    constructor() {
        this.isTerminating = Utils.notNullAndDefined(this.userCommunityTerminatingDate);
        // Transient
        this.showServices = false;
    }
    get userCommunityTerminatingDate() {
        return this.terminatingDate;
    }
    get websiteLink() {
        return !!this.website && this.website.startsWith('http') ? this.website : `http://${this.website}/`;
    }
    get managerUserDisplayText() {
        return Utils.notNullAndDefined(this.manager) ? this.manager.displayName : '';
    }
    get accountantUserDisplayText() {
        return Utils.notNullAndDefined(this.accountant) ? this.accountant.displayName : '';
    }
}
tslib_1.__decorate([
    Type(ɵ0),
    tslib_1.__metadata("design:type", UserPortfolioProfileResultDto)
], UserCommunitiesResultDto.prototype, "manager", void 0);
tslib_1.__decorate([
    Type(ɵ1),
    tslib_1.__metadata("design:type", UserPortfolioProfileResultDto)
], UserCommunitiesResultDto.prototype, "accountant", void 0);
tslib_1.__decorate([
    Type(ɵ2),
    tslib_1.__metadata("design:type", Date)
], UserCommunitiesResultDto.prototype, "startDate", void 0);
tslib_1.__decorate([
    Type(ɵ3),
    tslib_1.__metadata("design:type", Date)
], UserCommunitiesResultDto.prototype, "terminationDate", void 0);
tslib_1.__decorate([
    Type(ɵ4),
    tslib_1.__metadata("design:type", Date)
], UserCommunitiesResultDto.prototype, "terminatingDate", void 0);
tslib_1.__decorate([
    Exclude(),
    tslib_1.__metadata("design:type", Object)
], UserCommunitiesResultDto.prototype, "isTerminating", void 0);
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4 };
